//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/alertTypes/views/main/lan/es';
import alertTypeDetails from 'Modules/alertTypes/views/main/.components/alertTypeDetails/lan/es';

locales = {
    ...locales,
    ...main,
    ...alertTypeDetails,
};

export default locales;